"use strict";
/**
 * Built by SHO on 10/05/2019.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sequence = void 0;
const gsap_1 = require("gsap");
const pixi_js_1 = require("pixi.js");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const MathHelper_1 = require("../utils/MathHelper");
const Helper_1 = require("../utils/Helper");
class Sequence extends pixi_js_1.Sprite {
    static createSequence(texture) {
        const seq = new Sequence({ textures: texture ? texture : [] });
        seq.alpha = 0;
        seq.anchor.set(0.5, 0.5);
        seq.pivot.set(0, 0);
        return seq;
    }
    get timeline() {
        return this._timeline;
    }
    get isActive() {
        return this._timeline != undefined && this._timeline.isActive();
    }
    get totalFrames() {
        return this._config.textures.length;
    }
    get totalDuration() {
        return this.totalFrames * MathHelper_1.MathHelper.frameToSeconds(1);
    }
    get isReverse() {
        return !!this._config.reverse;
    }
    set isReverse(value) {
        this._config.reverse = value;
    }
    get frameDuration() {
        return this.totalDuration / this.totalFrames;
    }
    get firstFrame() {
        return this._config.textures[0];
    }
    get lastFrame() {
        return this._config.textures[this.totalFrames - 1];
    }
    get textures() {
        return this._config.textures;
    }
    get currentFrame() {
        if (!this._timeline)
            return 0;
        const frame = Math.floor(this.totalFrames * this._timeline.progress());
        return Math.max(0, Math.min(frame, this.totalFrames - 1));
    }
    getFrame(value) {
        return this._config.textures[(value == undefined ? this.currentFrame : value)];
    }
    get currentFrameTexture() {
        return this.texture;
    }
    set timeScale(value) {
        this.timeScaling = value;
    }
    constructor(config) {
        super();
        this.timeScaling = 1;
        this._config = config;
        this.renderNormal();
    }
    setFrame(frame) {
        this.texture = this._config.textures[frame];
    }
    setTexture(newTextures) {
        this._config.textures = newTextures;
        this.renderNormal();
    }
    playAnimation(config = {}) {
        this._timeline = Helper_1.Helper.timeLineKiller(this._timeline, new gsap_1.TimelineMax({
            onStart: config.onStart,
            onComplete: config.onCompleteCallback,
            repeat: config.repeat,
            repeatDelay: 0
        }), !!config.forceEnd);
        let duration = this.totalDuration;
        this.setFrame(config.reverse ? this.totalFrames - 1 : 0);
        if (config.clip) {
            const clip = this.getClip(config.clip);
            if (clip) {
                if (clip.to === undefined)
                    clip.to = this.totalFrames - 1;
                if (clip.from === undefined)
                    clip.from = 0;
                let amountOfFrames = Math.abs(clip.to - clip.from);
                const reversedFrames = clip.from > clip.to;
                let startFrame = config.reverse ? clip.to : clip.from;
                duration = config.duration === undefined ? amountOfFrames * MathHelper_1.MathHelper.frameToSeconds(1) : config.duration;
                duration *= config.speedFactor ? config.speedFactor : 1;
                this.setFrame(startFrame);
                this._timeline.to(this, duration, {
                    onUpdate: () => {
                        config.onUpdate && config.onUpdate();
                        const progressFrame = Math.floor(amountOfFrames * this._timeline.progress());
                        const frame = startFrame + (config.reverse || this.isReverse || reversedFrames ? -progressFrame : progressFrame);
                        this.texture = this._config.textures[frame];
                    },
                    onComplete: () => {
                        const frame = startFrame + (config.reverse || this.isReverse || reversedFrames ? -amountOfFrames : amountOfFrames);
                        this.texture = this._config.textures[frame];
                    }
                });
            }
            else
                Logger_1.Logger.warn("Missing clip: " + config.clip + ".");
        }
        else {
            duration = config.duration === undefined ? this.totalDuration : config.duration;
            duration *= config.speedFactor ? config.speedFactor : 1;
            this._timeline.to(this, duration, {
                onUpdate: () => {
                    config.onUpdate && config.onUpdate();
                    this.renderNormal(config.reverse);
                },
                onComplete: () => this.renderNormal()
            });
            this._timeline.play();
        }
        this._timeline.timeScale(this.timeScaling);
        return this._timeline;
    }
    reset(playEnd, tlReplace) {
        if (this._timeline && playEnd)
            this._timeline.totalProgress(1);
        this._timeline = Helper_1.Helper.timeLineKiller(this._timeline, tlReplace);
    }
    pause() {
        if (this._timeline)
            this._timeline.pause();
    }
    resume() {
        if (this._timeline)
            this._timeline.play();
    }
    stop(playToEnd = false) {
        if (this._timeline && this._timeline.isActive() && playToEnd)
            this._timeline.progress(1);
        this._timeline = Helper_1.Helper.timeLineNuller(this._timeline);
    }
    getClip(SearchName) {
        if (this._config.clips)
            return this._config.clips.find(clip => clip.name == SearchName);
        else
            return undefined;
    }
    setClips(clips) {
        this._config.clips = clips;
    }
    renderNormal(reverse) {
        let frame = this.isReverse || reverse ? (this.totalFrames - 1) - this.currentFrame : this.currentFrame;
        this.texture = this._config.textures[frame];
    }
    setVisible(value) {
        this.visible = value;
        this.alpha = value ? 1 : 0;
    }
    resetToDefault() {
        this.setFrame(this._config.reverse ? this.textures.length - 1 : 0);
        this.pivot.set(0, 0);
        this.scale.set(1, 1);
        this.blendMode = pixi_js_1.BLEND_MODES.NORMAL;
    }
}
exports.Sequence = Sequence;
//# sourceMappingURL=Sequence.js.map